import { createContext, type ReactElement } from 'react';

export const DialogContext = createContext<{
    openNewDialog: (dialog: ReactElement) => void;
    closeLastDialog: () => void;
    closeAllDialogs: () => void;
    isOpened: boolean;
    numberOfOpenDialogs: number;
} | null>(null);
